import { Component, Input, OnInit } from '@angular/core';
import { NbModalBase } from '@app/common/basic/models/nb-modal-base';
import { AlertMode } from '@app/common/basic/services/alert.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'nb-alert-modal',
  templateUrl: './nb-alert-modal.component.html',
  styleUrls: ['./nb-alert-modal.component.scss'],
})
export class NbAlertModalComponent extends NbModalBase implements OnInit {
  @Input()
  title: string;

  @Input()
  description: string;

  @Input()
  icon: string;

  @Input()
  mode: AlertMode;

  @Input()
  onClose: (modalResult: Subject<any>, modalRef: BsModalRef) => void;

  @Input()
  onDismiss: (modalResult: Subject<any>, modalRef: BsModalRef) => void;

  alertIconClass: { [key: string]: string } = {};

  ngOnInit() {
    switch (this.mode) {
      case 'confirm': {
        this.alertIconClass.color = '#007bff';
        break;
      }
      case 'info': {
        this.alertIconClass.color = '#138496';
        break;
      }
      case 'error': {
        this.alertIconClass.color = '#dc3545';
        break;
      }
      case 'warning': {
        this.alertIconClass.color = '#e0a800';
        break;
      }
      case 'success': {
        this.alertIconClass.color = '#28a745';
        break;
      }
    }
  }

  closeModal() {
    if (this.onClose) {
      return this.onClose(this.modalResult, this.modalRef);
    } else {
      super.closeModal();
    }
  }

  dismissModal() {
    if (this.onDismiss) {
      return this.onDismiss(this.modalResult, this.modalRef);
    } else {
      this.hideModal();
    }
  }
}
